import { IconButton, MicrophoneIcon } from '@treams/treams-ui';

export default function VoiceMemoButton(props: { loading?: boolean; onClick?: () => void }) {
	return (
		<IconButton
			type="destructive"
			icon={<MicrophoneIcon />}
			loading={props.loading}
			onClick={props.onClick}
		/>
	);
}
